export default {
    lastreadings_details_account_name: "Account",
    lastreadings_details_device_id: "Serial",
    lastreadings_details_manufacturer: "Manufacturer",
    lastreadings_details_age: "Age (Days)",
    lastreadings_details_event_name: "Event Name",
    lastreadings_details_last_message_time: "Last Reading",
    lastreadings_details_devices: "Devices",
    lastreadings_details_warning: "Warning",
    lastreadings_details_device_name: "Device Name",
    lastreadings_details_date: "Date",
}